export const SET_SUBSCRIPTIONSHISTORY = 'SET_SUBSCRIPTIONSHISTORY';
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
export const SET_LIMIT = 'SET_LIMIT';
export const SET_SUBSCRIPTIONSHISTORY_DETAIL = 'SET_SUBSCRIPTIONSHISTORY_DETAIL';
export const SET_SUBSCRIPTIONSHISTORY_DETAILS = 'SET_SUBSCRIPTIONSHISTORY_DETAILS';
export const SET_CURRENT_PAGE_DETAILS = 'SET_CURRENT_PAGE_DETAILS';
export const SET_LIMIT_DETAILS = 'SET_LIMIT_DETAILS';
